// extracted by mini-css-extract-plugin
export default {"parentContainer":"MatchInfo_parentContainer__PZizF","matchInfoWrapper":"MatchInfo_matchInfoWrapper__asZpL","rowHeading":"MatchInfo_rowHeading__izTYf"};